import { Box, HStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionStatus } from "../../../autogen/bff-api";
import { QUESTION_STATUS_COLORS } from "./questionStatusColors";

export const useQuestionStatusLabel = () => {
  const { t } = useTranslation();
  return (status: SeV2QuestionStatus): string => {
    switch (status) {
      case SeV2QuestionStatus.Unanswered:
        return t("Awaiting answer");
      case SeV2QuestionStatus.Answered:
        return t("Answered");
      case SeV2QuestionStatus.Published:
        return t("Sent to all tenderers");
    }
  };
};

export const QuestionStatusChip = ({ status }: { status: SeV2QuestionStatus }) => {
  const getLabel = useQuestionStatusLabel();
  const colors = QUESTION_STATUS_COLORS[status];
  return (
    <HStack
      as="span"
      display="inline-flex"
      spacing="1.5"
      bg={colors.bg}
      color={colors.fg}
      rounded="full"
      px="2.5"
      py="0.5"
      fontSize="xs"
      fontWeight="semibold"
      flexShrink={0}
    >
      <Box as="span" w="1.5" h="1.5" rounded="full" bg="currentColor" />
      <Box as="span">{getLabel(status)}</Box>
    </HStack>
  );
};
